<template>
    <div v-if="familyStore.family.isPartOfAnyFamily">
        <div v-if="familyStore.family.isFamilyOwnerHasPlan == false">
            <div class="demo-spacing-0 mb-1">
                <div class="alert alert-warning" role="alert">
                    <div class="alert-body">
                        {{ localizationStore.translate('family.owner.plan.missing.message') }}
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="row mx-auto">
                <div class="col-lg-8 col-md-8 col-12 mx-auto">
                    <div class="card">
                        <div class="pb-5 px-sm-0">
                            <div class="px-sm-4 mx-50">
                                <div class="card-header">
                                    <h1 class="mx-auto">
                                        {{ localizationStore.translate('locale.family.detail.title') }}
                                    </h1>
                                </div>
                                <div class="media">
                                    <div class="avatar bg-light-primary rounded mr-1">
                                        <div class="avatar-content">
                                            <vue-feather type="award" class="avatar-icon font-medium-3"></vue-feather>
                                        </div>
                                    </div>
                                    <div class="users">
                                        <h6 class="card-text mb-0">
                                            {{ localizationStore.translate('family.name') }}
                                        </h6>
                                        <small class="text-primary">{{ familyStore.family.family.name }}</small>
                                    </div>
                                    <div class="avatar bg-light-primary rounded ml-1 mr-1">
                                        <div class="avatar-content">
                                            <vue-feather type="user" class="avatar-icon font-medium-3"></vue-feather>
                                        </div>
                                    </div>
                                    <div class="users">
                                        <h6 class="mb-0">{{ localizationStore.translate('locale.family.head') }}</h6>
                                        <small class="text-primary"> {{ familyStore.family.familyOwnerName }} </small>
                                    </div>
                                    <div class="avatar bg-light-primary rounded ml-1 mr-1 ">
                                        <div class="avatar-content">
                                            <vue-feather type="log-out" class="avatar-icon font-medium-3"></vue-feather>
                                        </div>
                                    </div>
                                    <div class="users">
                                        <h6 class="card-text mb-0">
                                            {{ localizationStore.translate('family.member.leave.label') }}
                                        </h6>
                                        <small>
                                            <span role="button" class="text-danger p-auto leave-btn" @click="familyStore.leaveFamily({ family: familyStore.family.family.id, user: userStore.user.id })">
                                                {{ localizationStore.translate('family.member.leave.button.text') }}
                                            </span>
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <hr>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="familyStore.family.familyOwner">
        <div class="row mx-auto">
            <div class="col-lg-10 col-md-10 col-12 mx-auto">
                <div class="card">
                    <div class="pb-5 px-sm-0">
                        <div class="px-sm-4 mx-50">
                            <div class="card-header">
                                <h1 class="mx-auto">
                                    {{ localizationStore.translate('family.detail.title') }}
                                </h1>
                            </div>
                            <p class="text-center mb-5">
                                Invite up to 3 friends or family members to your <strong>Family</strong>.
                                <br>
                                Once your friend or family member registers, they will receive unlimited access to fix their credit for <strong>FREE</strong>.
                            </p>
        
                            <div class="row mb-4">
                                <div class="col-12 col-lg-4">
                                    <div class="d-flex justify-content-center mb-1">
                                        <div class="
                                            d-flex
                                            width-100
                                            height-100
                                            rounded-circle
                                            justify-content-center
                                            align-items-center
                                            bg-light-primary
                                        ">
                                            <vue-feather type="message-square" size="28" class="font-large-1" />
                                        </div>
                                    </div>
                                    <div class="text-center">
                                        <h6 class="fw-bolder mb-1">Send Invitation 💌</h6>
                                        <p>Send your invitation link to a family member via email.</p>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-4">
                                    <div class="d-flex justify-content-center mb-1">
                                        <div class="
                                            modal-refer-earn-step
                                            d-flex
                                            width-100
                                            height-100
                                            rounded-circle
                                            justify-content-center
                                            align-items-center
                                            bg-light-primary
                                        ">
                                            <vue-feather type="clipboard" size="28" class="font-large-1" />
                                        </div>
                                    </div>
                                    <div class="text-center">
                                        <h6 class="fw-bolder mb-1">Member Registers 👩🏻&zwj;💻</h6>
                                        <p>Family members creates a Creditfixrr "Self" Account.</p>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-4">
                                    <div class="d-flex justify-content-center mb-1">
                                        <div class="
                                            modal-refer-earn-step
                                            d-flex
                                            width-100
                                            height-100
                                            rounded-circle
                                            justify-content-center
                                            align-items-center
                                            bg-light-primary
                                        ">
                                            <vue-feather type="award" size="28" class="font-large-1" />
                                        </div>
                                    </div>
                                    <div class="text-center">
                                        <h6 class="fw-bolder mb-1">Free Unlimited Access 🎉</h6>
                                        <p>Family member gets unlimited access for FREE.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
        
                        <hr>
                        <div class="card card-app-design mb-4 justify-content-center" v-if="familyStore.family.canCreateFamily">
                            <div class="row">
                                <div class="col-lg-8">
                                    <div class="px-sm-5 mx-50" v-if="familyStore.family.family != null">
                                        <div v-if="familyStore.family.memberInviteCount >= 3 ">
                                        </div>
                                        <div v-else>
                                            <h4 class="fw-bolder mt-5 mb-1">Invite a Member.</h4>
                                            <form class="row g-1" action="">
                                                <div class="col-5">
                                                    <label class="form-label" for="email">
                                                        {{ localizationStore.translate('family.member.add.form.input.first.label') }}
                                                    </label>
                                                    <input type="text" class="form-control" name="email" id="email" v-model="inviteName">
                                                </div>
                                                <div class="col-lg-4 col-md-6 col-7 d-flex align-items-end">
                                                    <button type="button" class="btn btn-primary  waves-effect waves-float waves-light" v-on:click="inviteMember">
                                                        {{ localizationStore.translate('family.member.add.form.submit.button.text') }}
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div class="row mx-auto " v-else>
                                        <h4 class="mb-0 mt-2 text-danger">
                                            {{ localizationStore.translate('family.not.exists') }}
                                        </h4>
                                    </div>
                                </div>
                                <hr>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="familyStore.isFamilyFetched" >
        <div class="row">
            <div class="col-lg-12 col-md-12 col-12">
                <div class="card">
                    <div class="row p-4 text-center">
                        <div class="col-lg-6 col-md-6 col-12">
                            <h4 class="fw-bolder">
                                {{ localizationStore.translate('family.dashboard.purchase.title') }}
                            </h4>
                            <router-link
                                :to="{ name: 'billing-plans'}"
                                class="btn btn-outline-success mt-auto"
                                v-if="!userStore.user.hasPlan"
                            >
                                {{ localizationStore.translate('family.plan.purchase') }}
                            </router-link>
                        </div>
                        <div class="col-lg-6 col-md-6 col-12 border-left">
                            <h4 class="fw-bolder">
                                {{ localizationStore.translate('family.invite.member.title') }}
                            </h4>
                            <div class="d-flex justify-content-center text-left">
                                <div>
                                    <label class="form-label" for="invite-code">
                                        {{ localizationStore.translate('family.invite.member.input.first.label') }}
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        :class="{ 'is-invalid': vuelidate.inviteCode.$error }"
                                        name="invite-code"
                                        id="invite-code"
                                        v-model="inviteCode"
                                    />
                                    <span v-if="vuelidate.inviteCode.$error" class="invalid-feedback" role="alert">
                                        <strong>Field is Required</strong>
                                    </span>
                                </div>
                                <button type="button" class="btn btn-primary waves-effect waves-float waves-light mt-auto ml-1" v-on:click="joinFamily">
                                    {{ localizationStore.translate('family.invite.member.button.text') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <loading v-else/>
    <edit-family-modal id="edit-family-modal"/>
</template>
<script>
import { ref,reactive } from 'vue'
import { useFamilyStore } from '../../stores/FamilyStore.js'
import { useLocalizationStore } from '../../stores/LocalizationStore.js'
import { useUserStore } from '../../stores/UserStore.js'
import EditFamilyModal from './EditFamilyModal'
import axios from 'axios'
import Clipboard from 'clipboard';
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import Swal from 'sweetalert2'
import { BPopover } from 'bootstrap-vue-3'
import Loader from '../report/Loader.vue'
export default{
    components:{
        EditFamilyModal,
        BPopover,
        'loading': Loader,
    },
    setup() {
        const inviteCode = ref(null);
        return {
            familyStore: useFamilyStore(),
            localizationStore: useLocalizationStore(),
            userStore: useUserStore(),
            inviteError: reactive({}),
            inviteName: ref(null),
            inviteCode,
            vuelidate: useVuelidate(
                {
                    inviteCode: {
                        required
                    }
                },
                {
                    inviteCode
                }
            ),
        }
    },
    mounted() {
        this.familyStore.fetchFamily();
        var clipboard = new Clipboard('.copy-accept-url');
        clipboard.on('success', function (e) {
            e.clearSelection();
            toastr.success('Invite Url is Copied', 'Copied!');
        });
        clipboard.on('error', function (e) {
            console.error('Action:', e.action);
            console.error('Trigger:', e.trigger);
        });
        var copyInviteCode = new Clipboard('.copy-invite-code');
        copyInviteCode.on('success', function (e) {
            e.clearSelection();
            toastr.success('Invite Code is Copied', 'Copied!');
        });
        clipboard.on('error', function (e) {
            console.error('Action:', e.action);
            console.error('Trigger:', e.trigger);
        });
    },
    methods:{
        
        
    }
}
</script>
